import { Facet } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../base.component';
import defaultHtml from './tabs.component.hbs';

export class TabsComponent extends BaseComponent<Facet> {
    protected override bindEvent = 'hawksearch:bind-tabs';
    protected override customTemplatePropertyName = 'tabs';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.values?.length) {
            return '';
        }

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-tab-value]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const value = element.getAttribute('hawksearch-tab-value');

                searchService.selectTab(value ?? undefined);
            });
        });
    }
}
